import React, { useEffect, useState } from "react";
import { Switch, Route } from "react-router";
import Card from "../cards/card";
import SeasonPage from "../pages/seasonPage";
import NormalPage from "../pages/normalPage";
import ArticlePage from "../pages/articlePage";
import Tab from "../cards/tab";
import Ticker from "../cards/ticker";
import ExternalPage from "../pages/externalPage";
import InternalPage from "../pages/internalPage";
import VCMSCard from "../videocloud/vcms";
import Color from "../colors/colors";
import Branding from "../branding/branding";
import Menus from "../menu/menu";
import Pages from "../pages/pages";
import VideoPage from "../pages/videoPage";
import AudioPage from "../pages/audioPage";
import Elements from "../elements/elements";
import TickersPage from "../ticker/ticker";
import ImagesTable from "../images/imageTable";
import LivePage from "../pages/livePage";
import Home from "../home/home";
import AlHome from "../home/alhome";
import Setting from "../setting/setting";
import WebSetting from "../setting/websetting";
import AppSetting from "../setting/appsetting";
import Monetize from "../monetize/monetize";
import Analytics from "../analytics/analytics";
import FilesTable from "../images/fileTable";
import TextPage from "../pages/textPage";
import ClientFooter from "../clientFooter/footer";
import Fonts from "../font/font";
import Subscription from "../subscribe/subscribe";
import UserList from "../userList/user.js";
import TextGrid from "../cards/textGrid";
import HighlightTextGrid from "../cards/highlightTextGrid";
import NavList from "../menuList/menuList";
import ErrorPage from "../errorPage/errorpage";
import Login from "../login/login";
import Loader from "../loader/loader";
import { UserStore } from "../../store/userStore";
import ChangePassword from "../userList/paswordChange";
import Profile from "../profile/profile";
import PasswordChange from "../profile/paswordChange";
import VideoReport from "../videoReport/VideoReport";
import SubReport from "../subscriptionReport/subReport";
import VideoDetails from "../videoReport/VideoDetails";
import Language from "../language/language";
import Live from "../live/live";
import Epg from "../cards/epg";
import Embed from "../cards/embed";
import ListPage from "../pages/listPage";
import EPGDetail from "../list/epgDetailList2";
import Gallery from "../cards/gallery";
import { getApplicationId } from "../../api/common";
import Analytics_Report from "../analytics/analytics_report";
import LogReport from "../log/log";
import PublishNotification from "../notification/notification";

const Indexer = (props) => {
  const [name, setName] = useState("");
  const appID = getApplicationId();

  const user = UserStore.useState((s) => s.user); //persisting state Pull state
  useEffect(() => {
    setName(props.name);
  }, [props.name]);

  //
  if (name && appID) {
    return (
      <Switch>
        <Route
          path="/page/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? NormalPage
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/normalpage/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? NormalPage
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/articlepage/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? ArticlePage
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/seasonpage/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? SeasonPage
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/externalpage/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? ExternalPage
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/internalpage/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? InternalPage
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/textpage/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? TextPage
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/listpage/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? ListPage
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/item/gallery/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? Gallery
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/item/:type/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? Card
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/ticker/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? Ticker
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/tickers"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? TickersPage
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route path="/tab/:id" component={Tab} />
        <Route
          path="/textGrid/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? TextGrid
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/menu/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? NavList
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/highlightTextGrid/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? HighlightTextGrid
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/epg/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? Epg
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/embed/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? Embed
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/vcms"
          component={
            name.superAdmin === true || name.admin === true
              ? VCMSCard
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/live"
          component={
            name.superAdmin === true || name.admin === true
              ? Live
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/colors"
          component={
            name.superAdmin === true || name.admin === true
              ? Color
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/branding"
          component={
            name.superAdmin === true || name.admin === true
              ? Branding
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/menu"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? Menus
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/footer"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? ClientFooter
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/fonts"
          component={
            name.superAdmin === true || name.admin === true
              ? Fonts
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/subscription"
          component={
            name.superAdmin === true || name.admin === true
              ? Subscription
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/pages"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? Pages
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/users"
          component={
            name.superAdmin === true ? UserList : name ? ErrorPage : Loader
          }
        />
        <Route
          path="/changepassword"
          component={
            name.superAdmin === true
              ? ChangePassword
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/elements"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? Elements
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/videopage/:id"
          component={
            name.superAdmin === true || name.admin === true
              ? VideoPage
              : name
                ? ErrorPage
                : Loader
          }
        />
         <Route
          path="/audiopage/:id"
          component={
            name.superAdmin === true || name.admin === true
              ? AudioPage
              : name
              ? ErrorPage
              : Loader
          }
        />
        <Route
          path="/livepage/:id"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? LivePage
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/epgdetail"
          component={
            name.superAdmin === true ||
            name.admin === true ||
            name.editor === true
              ? EPGDetail
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/images"
          component={
            name.editor === true ||
            name.superAdmin === true ||
            name.admin === true
              ? ImagesTable
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/files"
          component={
            name.editor === true ||
            name.superAdmin === true ||
            name.admin === true
              ? FilesTable
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/setting"
          component={
            name.superAdmin === true || name.admin === true
              ? Setting
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/websetting"
          component={
            name.superAdmin === true || name.admin === true
              ? WebSetting
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/appsetting"
          component={
            name.superAdmin === true || name.admin === true
              ? AppSetting
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/adTag"
          component={
            name.superAdmin === true || name.admin === true
              ? Monetize
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/log"
          component={
            name.superAdmin === true || name.admin === true
              ? LogReport
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route
          path="/notification"
          component={
            name.superAdmin === true || name.admin === true
              ? PublishNotification
              : name
                ? ErrorPage
                : Loader
          }
        />
        <Route path="/analytics" component={Analytics} />
        <Route path="/language" component={Language} />
        <Route path="/videoreport" component={VideoReport} />
        <Route path="/videodetails" component={VideoDetails} />
        <Route path="/subscriptionreport" component={SubReport} />
        <Route
          path="/analyticreport"
          component={
            appID === "63a73eba71dc820fb05e7928"
              ? Analytics_Report
              : name
                ? ErrorPage
                : Loader
          }
        />
        {/* <Route path="/analyticreport" component={Analytics_Report} />  */}
        <Route path="/profile" component={Profile} />
        <Route path="/passwordchange" component={PasswordChange} />
        <Route exact path="/login" component={Login}></Route>
        {/* <Route path="/dashboard" component={appID==="63a73eba71dc820fb05e7928"?AlHome:Home} /> */}
        <Route
          path="/dashboard"
          component={appID === "63a73eba71dc820fb05e7928" ? AlHome : Home}
        />

        <Route
          path="/analytics"
          component={appID === "63a73eba71dc820fb05e7928" ? AlHome : Home}
        />
        {/* <Route path="/dashboard" component={AlHome} />  */}
        <Route path="/error" component={ErrorPage} />
        <Route
          path="/"
          component={appID === "63a73eba71dc820fb05e7928" ? AlHome : Home}
        />
      </Switch>
    );
  } else {
    return <Loader></Loader>;
  }
};
export default Indexer;
